module.exports = __webpack_public_path__ + "static/media/play-icon.b5640f24.svg";